/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import React, { useEffect } from 'react';
import { Toolbar as ToolbarKit } from '@veeam/components';
import { observer } from 'mobx-react-lite';

import type { ToolbarProps } from '@veeam/components/lib/Toolbar/types';

import { useGridApi } from '../Grid/hooks';
import { SelectionMode } from '../Grid/enums';

import type { ToolbarItem } from './interfaces';

export const Toolbar = observer((props: ToolbarProps & { items: ToolbarItem[]; }) => {
    const gridApi = useGridApi();

    const { selectionMode, filters } = gridApi;

    useEffect(() => {
        gridApi.appendContextMenu(props.items, props.groups);
    }, [gridApi.selected]);

    if (gridApi && gridApi.selected) {
        // inject selected rows/filters/selectionMode into our toolbar
        const payload = {
            filters,
            selectedItems: gridApi.selected as Record<string, unknown>[],
            flags: {
                isAllPageMode: selectionMode === SelectionMode.AllPages,
            },
            ...props?.payload,
        };

        return <ToolbarKit {...props} payload={payload} />;
    } else {
        return <ToolbarKit {...props} />;
    }
});
